import React from 'react';
import {
  ChartBarIcon,
  CurrencyDollarIcon,
  ShoppingCartIcon,
  CubeIcon,
} from '@heroicons/react/24/outline';

interface StatCardProps {
  title: string;
  value: string;
  description: string;
  icon: React.ReactNode;
  color: 'blue' | 'green' | 'yellow' | 'red';
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  description,
  icon,
  color,
}) => {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600',
    green: 'bg-green-50 text-black',
    yellow: 'bg-yellow-50 text-yellow-600',
    red: 'bg-red-50 text-red-600',
  };

  const iconColorClass = colorClasses[color];

  return (
    <div className='bg-white rounded-lg shadow p-5'>
      <div className='flex items-center justify-between'>
        <div>
          <p className='text-sm font-medium text-gray-500'>{title}</p>
          <p className='text-2xl font-semibold mt-1'>{value}</p>
        </div>
        <div className={`p-3 rounded-full ${iconColorClass}`}>{icon}</div>
      </div>
      {description && (
        <div className='mt-4'>
          <p className='text-sm text-gray-500'>{description}</p>
        </div>
      )}
    </div>
  );
};

interface DashboardStatsProps {
  totalRevenue: number;
  totalOrders: number;
  averageOrderValue: number;
  lowStockItems: number;
  dateRange: string;
  comparisonDateRange: string;
  revenueChange: number;
  ordersChange: number;
  averageOrderValueChange: number;
}

const DashboardStats: React.FC<DashboardStatsProps> = ({
  totalRevenue,
  totalOrders,
  averageOrderValue,
  lowStockItems,
  dateRange,
  comparisonDateRange,
  revenueChange,
  ordersChange,
  averageOrderValueChange,
}) => {
  const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND',
    }).format(value);
  };

  return (
    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5'>
      <StatCard
        title='Doanh thu'
        value={formatCurrency(totalRevenue)}
        description=''
        icon={<CurrencyDollarIcon className='h-6 w-6' />}
        color='green'
      />

      <StatCard
        title='Đơn hàng'
        value={totalOrders.toString()}
        description=''
        icon={<ShoppingCartIcon className='h-6 w-6' />}
        color='green'
      />

      <StatCard
        title='Giá trị TB'
        value={formatCurrency(averageOrderValue)}
        description=''
        icon={<ChartBarIcon className='h-6 w-6' />}
        color='yellow'
      />

      <StatCard
        title='Sản phẩm active'
        value={lowStockItems.toString()}
        description='Sản phẩm đang bán trên hệ thống'
        icon={<CubeIcon className='h-6 w-6' />}
        color='green'
      />
    </div>
  );
};

export default DashboardStats;
